import { render } from "./modal-wait.vue?vue&type=template&id=2503e1ee"
import script from "./modal-wait.vue?vue&type=script&lang=js"
export * from "./modal-wait.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__